/* eslint-disable no-empty-pattern */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { AppAlert } from "../../../../components/dialogue/Dialogue";
import { useAppSelector } from "../../../../redux/hooks";
import { TagsTable } from "./TagsTable";
import { setTags } from "../../../../redux/reducers";
import { Container } from "../../../../globalstyled";
import AppLoader from "../../../../components/loader";
import { useFetchTags } from "../../../../apolloClient/hooks/itemCreation/fetchHooks";

interface TagsProp {
  permissions: boolean;
}

const Tags: React.FC<TagsProp> = ({permissions}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  const userReducer = useAppSelector((state) => state.userReducer);
  const { tags } = userReducer;

  const {
    loading,
    error,
    tags: tagsData,
    refetch,
  } = useFetchTags({
    limit: 100,
    offset: 0,
  });

  const handleRefetch = useCallback(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    onFetchTagsFields();
  }, [loading, error, dispatch, tagsData, handleRefetch]);

  const onFetchTagsFields = async () => {
    if (!loading && !error && tagsData) {
      dispatch(setTags(tagsData));
      setIsLoading(false);
    } else if (error) {
      console.error("Error fetching Tags:", error);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <AppLoader isLoading={isLoading} />;
  }

  const hostContainer = () => {
    return (
      <Container>
        <AppAlert
          open={false}
          title={`Reset Password!`}
          message={"Are you sure to Reset Your Password?"}
          onClose={() => {}}
          onConfirm={() => {}}
        />
        <TagsTable
          tagsData={tags || []}
          refetchTags={handleRefetch}
          permissions={permissions}
        />
      </Container>
    );
  };

  return hostContainer();
};

export default Tags;